module.exports = __webpack_public_path__ + "static/media/Sophie Himsworth Alcove Units.edb02183.jpg";